import React, { Component } from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import { CssBaseline, CircularProgress, Container, Button, Grid, Tabs, Tab, IconButton, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Divider } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import MyMaterialTable from '../../components/table';
import AddIcon from '@material-ui/icons/Add';
import RestoreIcon from '@material-ui/icons/Restore';
import RefreshIcon from '@material-ui/icons/Refresh';
import EventBusyIcon from '@material-ui/icons/EventBusy';
import { Link } from 'react-router-dom';
import Footer from '../../components/footer';
import { FormattedMessage, injectIntl } from 'react-intl';
import SectionCard from '../../components/section-card';
import Typography from '@material-ui/core/Typography';
import Pagination from '@material-ui/lab/Pagination';
import Search from '@material-ui/icons/Search';
import TextField from '@material-ui/core/TextField';
import ClearIcon from '@material-ui/icons/Clear';
import CloseIcon from '@material-ui/icons/Close';
import { ContractStatusBadge, ProvisioningStatusBadge } from '../../components/status-badge';
import DeprovisionedTrialDetailDialog from '../../components/deprovisioned-trial-detail-dialog';
import DeprovisioningStatsBanner from '../../components/deprovisioning-stats-banner';
import EmptyStateCard from '../../components/empty-state-card';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import * as componentActions from '../../redux/actions/admin-billing';
import * as adminBillingService from '../../services/admin-billing.service';
import Api from "../../services/api";

const PAGE_SIZE = 10;

class AdminTrialList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            resultList: [],
            totalPages: 0,
            page: 1,
            pageStart: 0,
            pageEnd: 0,
            count: 0,
            searchValue: '',
            statusFilter: '',
            tabValue: 0,
            confirmDialog: { open: false, title: '', message: '', action: null, color: '#f44336' },
            deprovisionedDialog: { open: false, desprovisioningQueueId: null },
            reloadTick: 0,
            checkingExpiration: false,
        };

        this.callSearch = this.callSearch.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.closeNotification = this.closeNotification.bind(this);
        this.clearFields = this.clearFields.bind(this);
    }

    componentDidMount() {
        this.getItens(1);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location.state === "reload") {
            this.componentDidMount();
        }
    }

    onChangePaginate = (e, page) => {
        this.setState({ page: page });
        this.getItens(page);
    }

    setPagination(count, page) {
        let totalPage = Math.ceil(count / PAGE_SIZE);
        this.setState({ totalPages: totalPage });
        if (count > 0) {
            if (page == 1) {
                this.setState({ pageStart: 1, pageEnd: Math.min(count, PAGE_SIZE) });
            } else {
                let pageStart = ((page - 1) * PAGE_SIZE) + 1;
                this.setState({ pageStart: pageStart, pageEnd: Math.min(page * PAGE_SIZE, count) });
            }
        } else {
            this.setState({ totalPages: 0, page: 1, count: 0 });
        }
    }

    onFieldChange(event) {
        this.setState({ [event.target.name]: event.target.value, page: 1 });
    }

    callSearch() {
        this.getItens(1);
    }

    async clearFields() {
        await this.setState({ searchValue: '', page: 1 });
        this.getItens(1);
    }

    handleTabChange = (e, newValue) => {
        const filters = ['', 'active', 'expired', 'converted', 'cancelled', 'deprovisioned'];
        this.setState({ tabValue: newValue, statusFilter: filters[newValue], page: 1 }, () => {
            this.getItens(1);
        });
    }

    openConfirm = (title, message, action, color = '#f44336') => {
        this.setState({ confirmDialog: { open: true, title, message, action, color } });
    }

    handleCheckTrialExpiration = (rowData) => {
        if (!rowData?.hirerid) return;
        this.openConfirm(
            'Verificar trial agora',
            `Esta ação dispara imediatamente a mesma verificação que o cron executa periodicamente, mas escopada para o trial "${rowData.name || rowData.workspace}" (workspace: ${rowData.workspace}). Se o trial estiver expirado (trial_end_date já passou), será marcado como "Expirado" e seu desprovisionamento será agendado (15min de período de carência). Deseja continuar?`,
            () => {
                this.setState({ confirmDialog: { open: false }, loading: true, checkingExpiration: true });
                adminBillingService.dispatchMaintenanceJob('check_trial_expiration', rowData.hirerid, true)
                    .then(result => {
                        if (result.data.success) {
                            this.setState({
                                checkingExpiration: false,
                                openNotification: true,
                                notificationVariant: 'success',
                                notificationMessage: 'Verificação disparada com sucesso. A lista será atualizada em instantes.'
                            });
                            setTimeout(() => this.getItens(this.state.page), 1500);
                        } else {
                            this.setState({
                                loading: false,
                                checkingExpiration: false,
                                openNotification: true,
                                notificationVariant: 'error',
                                notificationMessage: result.data.errors?.[0] || 'Falha ao disparar verificação'
                            });
                        }
                    })
                    .catch(err => {
                        this.setState({
                            loading: false,
                            checkingExpiration: false,
                            openNotification: true,
                            notificationVariant: 'error',
                            notificationMessage: err.response?.data?.errors?.[0] || 'Falha ao disparar verificação'
                        });
                        Api.kickoff(err);
                    });
            },
            '#f57c00'
        );
    }

    handleReactivateTrial = (rowData) => {
        const intl = this.props.intl;
        this.openConfirm(
            intl.formatMessage({ id: "admin.trial.reactivate.title" }),
            intl.formatMessage({ id: "admin.trial.reactivate.confirm" }, { name: rowData.name || '', workspace: rowData.workspace || '' }),
            () => {
                this.setState({ confirmDialog: { open: false }, loading: true });
                adminBillingService.reactivateTrial(rowData.hirerid)
                    .then(result => {
                        if (result.data.success) {
                            this.setState({ loading: false, openNotification: true, notificationVariant: 'success', notificationMessage: intl.formatMessage({ id: "admin.trial.reactivate.success" }) });
                            this.getItens(this.state.page);
                        } else {
                            this.setState({ loading: false, openNotification: true, notificationVariant: 'error', notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" }) });
                        }
                    })
                    .catch(err => {
                        this.setState({ loading: false, openNotification: true, notificationVariant: 'error', notificationMessage: intl.formatMessage({ id: "process.error" }) });
                        Api.kickoff(err);
                    });
            },
            '#4caf50'
        );
    }

    getItens(page = 1) {
        this.setState(s => ({ loading: true, reloadTick: (s.reloadTick || 0) + 1 }));
        const offset = (page - 1) * PAGE_SIZE;

        adminBillingService.getTrials(PAGE_SIZE, offset, this.state.searchValue, this.state.statusFilter)
            .then(result => {
                if (result.data.success) {
                    const data = result.data.data;
                    const count = data.totalcount || 0;
                    const trials = data.trials || [];
                    this.setState({ count: count });
                    this.setPagination(count, page);

                    const formattedList = trials.map(item => {
                        return {
                            ...item,
                            daysRemainingText: item.daysremaining != null ? (item.daysremaining > 0 ? `${item.daysremaining} dias` : 'Expirado') : '-',
                            trialEndDateText: item.trialenddate ? new Date(item.trialenddate).toLocaleDateString('pt-BR') : '-',
                            convertedAtText: item.convertedat ? new Date(item.convertedat).toLocaleString('pt-BR') : '-',
                            convertedByText: item.convertedby ? item.convertedby.replace('admin:', '') : '-',
                            convertedToPlanText: item.convertedtoplan || '-',
                            conversionReasonText: item.conversionreason || '-',
                        };
                    });

                    this.setState({ loading: false, resultList: formattedList });
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                const intl = this.props.intl;
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    getActionColumn() {
        const intl = this.props.intl;
        return {
            title: intl.formatMessage({ id: "actions" }),
            field: 'actions',
            render: rowData => {
                // Cancelar e Excluir foram movidos exclusivamente para a tela de detalhe (admin-trial-detail).
                // Listagem mantém apenas Reativar como ação rápida (não destrutiva).
                const canReactivate = rowData.contractstatusid === 4;
                // Verificar agora: só faz sentido em trials no status "Em Trial" (5) — adianta a verificação
                // de expiração que normalmente é feita pelo cron.
                const canCheckExpiration = rowData.contractstatusid === 5;
                return (
                    <div style={{ display: 'flex', gap: 2 }}>
                        {canCheckExpiration && (
                            <Tooltip title="Verificar agora se o trial expirou (adianta o cron)">
                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); this.handleCheckTrialExpiration(rowData); }}>
                                    <EventBusyIcon style={{ color: '#f57c00' }} />
                                </IconButton>
                            </Tooltip>
                        )}
                        {canReactivate && (
                            <Tooltip title={intl.formatMessage({ id: "admin.trial.reactivate" })}>
                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); this.handleReactivateTrial(rowData); }}>
                                    <RestoreIcon style={{ color: '#4caf50' }} />
                                </IconButton>
                            </Tooltip>
                        )}
                    </div>
                );
            }
        };
    }

    render() {
        const { classes, headerMenu } = this.props;
        const intl = this.props.intl;
        const { confirmDialog } = this.state;
        const actionColumn = this.getActionColumn();

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open })} >
                    <div className={classes.drawerHeader} />
                    <Container component='main' maxWidth='xl' style={{ paddingLeft: 0, marginLeft: 0 }}>
                        <CssBaseline />
                        <Grid container className={classes.mb20} spacing={0}>
                            <Grid item xs={12}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="large"
                                    className={classes.button}
                                    startIcon={<AddIcon />}
                                    style={{ marginRight: 5, marginBottom: 5 }}
                                    component={Link} {...{ to: `/${this.props.match.params.lang}/admin-trial-create` }}
                                >
                                    {intl.formatMessage({ id: "admin.trials.create" })}
                                </Button>
                            </Grid>
                        </Grid>

                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <SectionCard
                                    context="list"
                                    title={intl.formatMessage({ id: "admin.trials.title" })}
                                    actions={
                                        <Tooltip title="Atualizar">
                                            <IconButton size="small" onClick={() => this.getItens(this.state.page)}><RefreshIcon /></IconButton>
                                        </Tooltip>
                                    }
                                >
                                    <Grid container spacing={1} alignItems="center">
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                type="text"
                                                name="searchValue"
                                                value={this.state.searchValue}
                                                placeholder={intl.formatMessage({ id: "search" })}
                                                onChange={this.onFieldChange}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                InputProps={{ startAdornment: <Search style={{ color: '#757575', marginRight: 8 }} /> }}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <Button variant='contained' color='secondary' size='medium' onClick={this.callSearch} startIcon={<Search />} style={{ textTransform: 'none' }}>
                                                Buscar
                                            </Button>
                                        </Grid>
                                        <Grid item>
                                            <Button variant='outlined' color='primary' size='medium' onClick={this.clearFields} startIcon={<ClearIcon />} style={{ textTransform: 'none' }}>
                                                Limpar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </SectionCard>
                            </Grid>
                        </Grid>

                        <Tabs value={this.state.tabValue} onChange={this.handleTabChange} indicatorColor="primary" textColor="primary" style={{ marginBottom: 8 }}>
                            <Tab label={intl.formatMessage({ id: "admin.trials.filter.all" })} />
                            <Tab label={intl.formatMessage({ id: "admin.trials.filter.active" })} />
                            <Tab label={intl.formatMessage({ id: "admin.trials.filter.expired" })} />
                            <Tab label={intl.formatMessage({ id: "admin.trials.filter.converted" })} />
                            <Tab label={intl.formatMessage({ id: "admin.trials.filter.cancelled" })} />
                            <Tab label={intl.formatMessage({ id: "admin.trials.filter.deprovisioned" })} />
                        </Tabs>

                        {this.state.tabValue === 0 && (
                            <div style={{ marginBottom: 12, padding: '8px 12px', backgroundColor: '#fff8e1', borderLeft: '3px solid #ffb300', borderRadius: 4, fontSize: 12, color: '#6d4c00' }}>
                                Trials <strong>desprovisionados</strong> não aparecem nesta aba. Veja-os na aba <strong>"Desprovisionados"</strong>.
                            </div>
                        )}

                        {this.state.statusFilter === 'deprovisioned' && (
                            <DeprovisioningStatsBanner contractType="trial" refreshKey={this.state.reloadTick} />
                        )}

                        {this.state.resultList.length === 0 && !this.state.loading ? (
                            <EmptyStateCard
                                context={this.state.statusFilter === 'deprovisioned' ? 'success' : 'info'}
                                icon={<HourglassEmptyIcon style={{ fontSize: 56, color: '#bdbdbd' }} />}
                                title={this.state.statusFilter === 'deprovisioned' ? 'Nenhum trial desprovisionado' : 'Nenhum trial encontrado'}
                                description={this.state.statusFilter === 'deprovisioned' ? 'Ainda não há trials neste estado.' : 'Ajuste os filtros ou crie um novo trial.'}
                            />
                        ) : (
                            <MyMaterialTable
                                title=""
                                columns={this.state.statusFilter === 'converted' ? [
                                    { title: 'Contrato', field: 'contractid' },
                                    { title: intl.formatMessage({ id: "name" }), field: 'name' },
                                    { title: 'Workspace', field: 'workspace' },
                                    { title: intl.formatMessage({ id: "admin.trial.converted.plan" }), field: 'convertedToPlanText' },
                                    { title: intl.formatMessage({ id: "admin.trial.converted.date" }), field: 'convertedAtText' },
                                    { title: intl.formatMessage({ id: "admin.trial.converted.by" }), field: 'convertedByText' },
                                    { title: intl.formatMessage({ id: "admin.trial.converted.reason" }), field: 'conversionReasonText' },
                                    {
                                        title: 'Status Contrato',
                                        field: 'contractstatusid',
                                        render: rowData => <ContractStatusBadge statusId={rowData.contractstatusid} />
                                    },
                                ] : [
                                    { title: 'Contrato', field: 'contractid' },
                                    { title: intl.formatMessage({ id: "name" }), field: 'name' },
                                    { title: 'Workspace', field: 'workspace' },
                                    { title: intl.formatMessage({ id: "admin.trial.end.date" }), field: 'trialEndDateText' },
                                    { title: intl.formatMessage({ id: "admin.trial.days.remaining" }), field: 'daysRemainingText' },
                                    {
                                        title: 'Status Contrato',
                                        field: 'contractstatusid',
                                        render: rowData => <ContractStatusBadge statusId={rowData.contractstatusid} />
                                    },
                                    {
                                        title: 'Status Provisionamento',
                                        field: 'provisioningstatus',
                                        render: rowData => rowData.provisioningstatus ? <ProvisioningStatusBadge status={rowData.provisioningstatus} /> : '-'
                                    },
                                    actionColumn,
                                ]}
                                data={this.state.resultList}
                                rowClick={
                                    this.state.statusFilter === 'converted' ? undefined
                                    : this.state.statusFilter === 'deprovisioned'
                                        ? (event, rowData) => {
                                            if (rowData?.desprovisioningqueueid) {
                                                this.setState({ deprovisionedDialog: { open: true, desprovisioningQueueId: rowData.desprovisioningqueueid } });
                                            }
                                          }
                                        : (event, rowData) => {
                                            this.props.addCurrentTrial(rowData);
                                            this.props.history.push(`/${this.props.match.params.lang}/admin-trial-detail`);
                                          }
                                }
                            />
                        )}

                        <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                            <Grid item xs={12} md={3}>
                                <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                            </Grid>
                            <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                                {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
                            </Grid>
                        </Grid>

                        {/* Confirm Dialog */}
                        <Dialog open={confirmDialog.open} onClose={() => this.setState({ confirmDialog: { open: false } })} maxWidth="xs" fullWidth PaperProps={{ style: { borderRadius: 12, overflow: 'hidden' } }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 24px', backgroundColor: '#f5f7fa' }}>
                                <Typography variant="h6" style={{ fontWeight: 600, fontSize: 18 }}>{confirmDialog.title}</Typography>
                                <IconButton size="small" onClick={() => this.setState({ confirmDialog: { open: false } })} style={{ color: '#9e9e9e' }}><CloseIcon fontSize="small" /></IconButton>
                            </div>
                            <Divider />
                            <DialogContent style={{ padding: '16px 24px' }}>
                                <Typography>{confirmDialog.message}</Typography>
                            </DialogContent>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '12px 24px 16px', backgroundColor: '#f5f5f5', borderTop: '1px solid #e0e0e0' }}>
                                <Button onClick={() => this.setState({ confirmDialog: { open: false } })} style={{ textTransform: 'none', fontWeight: 500 }}>{intl.formatMessage({ id: "cancel" })}</Button>
                                <Button variant="contained" onClick={confirmDialog.action} style={{ backgroundColor: confirmDialog.color || '#f44336', color: '#fff', textTransform: 'none', fontWeight: 600, borderRadius: 6 }}>
                                    {intl.formatMessage({ id: "confirm" })}
                                </Button>
                            </div>
                        </Dialog>

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />

                        <DeprovisionedTrialDetailDialog
                            open={this.state.deprovisionedDialog.open}
                            desprovisioningQueueId={this.state.deprovisionedDialog.desprovisioningQueueId}
                            onClose={() => this.setState({ deprovisionedDialog: { open: false, desprovisioningQueueId: null } })}
                            onForceDropSuccess={() => this.getItens(this.state.page)}
                            onDataRefreshed={() => this.getItens(this.state.page)}
                            defaultEmail={this.props.userSession?.user?.email || ''}
                        />

                    </Container>
                </main>
                <Footer />
            </div>
        );
    }
}

AdminTrialList.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AdminTrialList)));
